import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import DashboardHeader from "../../Components/DashboardHeader/DashboardHeader";

const DashboardLayout = () => {
	const navigate = useNavigate();
	const location = useLocation();

	// Check if we're on the information page to show search
	const isInformationPage =
		location.pathname === "/company/documents" ||
		location.pathname.includes("/company/documents");

	const isAuthenticated = Boolean(localStorage.getItem("token"));

	useEffect(() => {
		if (!isAuthenticated) {
			navigate("/login", { replace: true });
		}
	}, [isAuthenticated, navigate]);

	if (!isAuthenticated) {
		return null;
	}

	return (
    <Box
      display={"flex"}
      sx={{
        height: "100vh",
        backgroundColor: "#F6F5F8",
        color: "#2F2D3B",
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
        }}
      >
        <Sidebar />
      </Box>
      <Box
        sx={{
          width: "85%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {location.pathname !== "/company" && (
          <DashboardHeader showSearch={isInformationPage} />
        )}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            // overflowY: "scroll",
            // overflow: "hidden",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
